<nz-form-label class="lbl-multi" [attr.nzFor]="fieldCode" [hidden]="hideTitle" nzNoColon>
    <span>{{name}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</nz-form-label>
<nz-form-control class="control-multi" [formGroup]="formGroup">
    <div>
        <ng-container *ngFor="let option of customfieldOptionList">
            <label nz-checkbox [nzValue]="option.optionCode" id="multi{{fieldCode}}-{{option.optionCode}}" [attr.data-name]="fieldCode"
                [attr.data-checked]="option.checked" [attr.data-nzValue]="option.optionCode"
                [attr.data-multiCheckbox]="option.optionValue" [class]="addClass(option.fieldOptionConfig)"
                [(ngModel)]="option.checked" [nzDisabled]="option.disabled"
                name="multi{{fieldCode}}-{{option.optionCode}}" (ngModelChange)="changeCheckboxValue()"
                formControlName="{{fieldCode}}-{{option.optionCode}}">{{option.optionValue}}</label>
            <input autocomplete="off" nz-input id="{{fieldCode}}-{{option.optionCode}}_INPUT" *ngIf="option.allowInput"
                [disabled]="!option.checked" (focus)="focusInput(option)" (change)="changeValidate(option)"
                (blur)="checkValidEmail(option)" (keydown)="keydownValidateAllowInput(option)"
                (keypress)="keydownValidateAllowInput(option)" (keyup)="keydownValidateAllowInput(option)"
                nzSize="large" name="{{fieldCode}}-{{option.optionCode}}_INPUT"/>
            <div *ngIf="option.hasSubSession && itemList.length > 0" nz-row class="row sub-items"
                [hidden]="!option.checked">
                <span *ngFor="let c of itemList" [hidden]="c.isHidden" [ngClass]="getCol(c)">
                    <div *ngIf="c.fieldTypeCode == 'TITLE' && isShow(c, option)">
                        <app-component-title class="col-12" [ngClass]="fieldCode" [attr.query]="fieldCode" [formFieldInfo]="c" class="directive-component">
                        </app-component-title>
                    </div>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'TEXT' && isShow(c, option)">
                        <app-component-text [formFieldInfo]="c" id="{{c.fieldCode}}" [ngClass]="fieldCode" [attr.query]="fieldCode" [formGroup]="formGroup" class="directive-component">
                        </app-component-text>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'TABLE_COMPLEX' && isShow(c, option)">
                        <app-component-table-complex (tableEmit)="tableOutput($event)" [attr.query]="fieldCode" [ngClass]="fieldCode" [formFieldInfo]="c" [formGroup]="formGroup"
                            class="directive-component">
                        </app-component-table-complex>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'NUMBER' && isShow(c, option)">
                        <app-component-number id="{{c.fieldCode}}" [ngClass]="fieldCode" [attr.query]="fieldCode" [formFieldInfo]="c" [formGroup]="formGroup"
                            class="directive-component">
                        </app-component-number>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'TEXTAREA' && isShow(c, option)">
                        <app-component-textarea id="{{c.fieldCode}}" [ngClass]="fieldCode" [attr.query]="fieldCode" [formFieldInfo]="c"
                            class="directive-component">
                        </app-component-textarea>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'DATE' && isShow(c, option)">
                        <app-component-date id="{{c.fieldCode}}" [ngClass]="fieldCode" [attr.query]="fieldCode" [formFieldInfo]="c" [formGroup]="formGroup"
                            class="directive-component">
                        </app-component-date>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'DATETIME' && isShow(c, option)">
                        <app-component-datetime id="{{c.fieldCode}}" [ngClass]="fieldCode" [attr.query]="fieldCode" [formFieldInfo]="c"
                            class="directive-component">
                        </app-component-datetime>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'SELECTLIST_SINGLE' && isShow(c, option)">
                        <app-component-single-select id="{{c.fieldCode}}" [formFieldInfo]="c"
                            class="directive-component" (selectEmit)="selectOutput($event)"
                            [attr.query]="fieldCode"
                            [inputData]="selectChildData" [selectedOptionData]="selectedOptionData"
                            [formGroup]="formGroup" [ngClass]="fieldCode">
                        </app-component-single-select>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'SPACE' && isShow(c, option)">
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'MULTIPLE_CHOICE' && isShow(c, option)">
                        <app-component-multiple-choice id="{{c.fieldCode}}" [formFieldInfo]="c"
                            class="multi-choice-control directive-component" [ngClass]="fieldCode"
                            [inputCustomfieldOptionList]="getMultipleChoiceCustomfieldList(c)"
                            [attr.query]="fieldCode"
                            [itemList]="getSubItemsList(c)" [listFormFieldInfo]="listFormFieldInfo"
                            [formGroup]="formGroup" [formData]="formData">
                        </app-component-multiple-choice>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'RADIO_BUTTON' && isShow(c, option)">
                        <app-component-radiobutton id="{{c.fieldCode}}" [formFieldInfo]="c" [formGroup]="formGroup" [ngClass]="fieldCode"
                            [itemList]="getSubItemsList(c)" class="radio-button-control directive-component"
                            [attr.query]="fieldCode"
                            [listFormFieldInfo]="listFormFieldInfo" [formData]="formData">
                        </app-component-radiobutton>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'LABEL' && isShow(c, option)">
                        <app-component-label id="{{c.fieldCode}}" [ngClass]="fieldCode" [attr.query]="fieldCode" [formFieldInfo]="c" class="directive-component">
                        </app-component-label>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'CHECK_BOX' && isShow(c, option)">
                        <app-component-checkbox id="{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="fieldCode" [attr.query]="fieldCode"
                            class="directive-component">
                        </app-component-checkbox>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'NUMBER_CURRENCY' && isShow(c, option)">
                        <app-component-number-currency id="{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="fieldCode" [attr.query]="fieldCode"
                            class="directive-component">
                        </app-component-number-currency>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'TEXT_CHECK_BOX' && isShow(c, option)">
                        <app-component-text-checkbox id="{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="fieldCode" [attr.query]="fieldCode"
                            class="directive-component">
                        </app-component-text-checkbox>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'DATE_CHECK_BOX' && isShow(c, option)">
                        <app-component-date-checkbox id="{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="fieldCode" [attr.query]="fieldCode"
                            class="directive-component">
                        </app-component-date-checkbox>
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'TABLE' && isShow(c, option)">
                    </nz-form-item>
                    <nz-form-item *ngIf="c.fieldTypeCode == 'UPLOAD_FILE' && isShow(c, option)">
                    </nz-form-item>
                </span>
            </div>
        </ng-container>
    </div>
</nz-form-control>